export function calcConsignmentsDirtyWeight (position) {
  return position.consignments?.reduce(reduceDirtyWeight, 0) || 0
}

function reduceDirtyWeight (prev, current) {
  return prev + +current.weight_dirty
}
